var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      class: _vm.bemBlock,
      attrs: {
        "is-open": true,
        "modal-modifier": "pdp",
        "show-backdrop": true
      },
      on: {
        closed: function($event) {
          return _vm.$emit("in-store-stock-modal-closed")
        }
      }
    },
    [
      _c(
        "div",
        { class: _vm.bemElement("content-aside") },
        [
          _vm.isBreakpointDesktop
            ? _c("BaseImage", {
                class: _vm.bemElement("pic-aside"),
                attrs: {
                  loading: "eager",
                  image: _vm.getDefaultImageFromProductImageSet(_vm.mainImage),
                  placeholder: _vm.getPlaceholderImageFromProductImageSet(
                    _vm.mainImage
                  ),
                  sizes: _vm.imageAttributeSizes.IN_STORE_STOCK,
                  srcset: _vm.getSrcsetFromProductImageSet(_vm.mainImage)
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.bemElement("main-content"), "overflow"] },
        [
          _c(
            "h1",
            { class: [_vm.bemElement("title"), "the-product-details__title"] },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$msg("instorestock.title", "inStoreStock")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { class: _vm.bemElement("subtitle") }, [
            _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")
          ]),
          _vm._v(" "),
          !_vm.isSizeSelected
            ? _c("TheInStoreStockModalSizeSelector", {
                attrs: { product: _vm.product },
                on: {
                  "size:confirm": function(confirmedSizes) {
                    return (_vm.selectedSizes = confirmedSizes)
                  }
                }
              })
            : _c("BaseStoreLocator", { attrs: { url: _vm.storeLocatorUrl } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }